export default __webpack_public_path__ + "static/media/cat.dd6b37c4.png";